<!-- <p>confirm-tenant-user</p>
<h4 class="card-title">Mandant {{userTenant.tenantName}}</h4> -->

@if (isRelevantUser) {
  <div class="card">
    <mat-expansion-panel class="navbar-transparent" [expanded]="tenantVisible" (opened)="tenantVisible=true" (closed)="tenantVisible=false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4 class="card-title">Mandant {{userTenant.tenantName}}</h4>
          @if (!userTenant.isConfirmed) {
            <span style="color: red; margin-left: 15px">noch unbestätigt!</span>
          }
          @if (userTenant.isConfirmed) {
            <span style="color: darkgreen; margin-left: 15px">bestätigt!</span>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="panelContent">
        <form [formGroup]="userTenantForm" novalidate>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="E-Mail" formControlName="email" disabled>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Tel. Nr." formControlName="phoneNumber" maxlength="50">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <span style="flex: 1 1 auto"></span>
            <button matTooltip="Daten bestätigen/ändern" mat-button (click)="confirm()">
              <h5>Bestätigen</h5>
            </button>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
  </div>
}
